import React from 'react'
import { $DCprimaryColor, DcInput } from 'pixel-base'
import styled from 'styled-components'
import { LineItem } from '../../../../../../../decl.d'
interface IProps {
  isEditable: boolean
  newProductQuantity: { quantity: string }
  newOrder: boolean
  setNewOrderData: (data: any) => void
  newOrderData: any
  item: LineItem
  setNewProductQuantity: (data: any) => void
}
const QuantityContainer = (props: IProps) => {
  const {
    isEditable,
    newProductQuantity,
    newOrder,
    setNewOrderData,
    newOrderData,
    item,
    setNewProductQuantity,
  } = props
  return (
    <Quantity>
      {isEditable ? (
        <Quantity>
          <DcInput
            noPadding
            required
            isShowLabel={false}
            type="number"
            name={'Quantity'}
            min={'0'}
            placeholder={'Quantity'}
            value={newProductQuantity.quantity}
            onChange={(e) => {
              if (newOrder) {
                setNewOrderData({
                  ...newOrderData,
                  line_items: newOrderData.line_items.map((key) => {
                    if (key.product_id === item.product_id) {
                      return {
                        ...key,
                        quantity: Number(e.target.value),
                      }
                    }
                    return key
                  }),
                })
              } else {
                setNewProductQuantity({
                  ...newProductQuantity,
                  quantity: e.target.value,
                })
              }
            }}
          />
        </Quantity>
      ) : (
        <InlineSection>{item.quantity}</InlineSection>
      )}
    </Quantity>
  )
}
const Quantity = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`
const InlineSection = styled.div<{ color?: string }>`
  font-size: 12px;
  font-weight: 400;
  color: ${(props) =>
    props.color === 'primary' ? $DCprimaryColor : 'rgba(0, 0, 0, 0.87)'};
`
export default QuantityContainer
